import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import WorldHome from '@/views/WorldHome'
import Profile from '@/views/Profile'
import UserInfoUpload from '@/views/UserInfoUpload'
import IslandPlay from '@/views/IslandPlay'
import { isLoggedIn } from '@/utils/auth'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: { guest: true }
    },
    {
      path: '/home',
      name: 'WorldHome',
      component: WorldHome,
      meta: { requiresAuth: true }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: { requiresAuth: true }
    },
    {
      path: '/island/user-info',
      name: 'UserInfoUpload',
      component: UserInfoUpload,
      meta: { requiresAuth: true }
    },
    {
      path: '/island/play',
      name: 'IslandPlay',
      component: IslandPlay,
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const loggedIn = isLoggedIn()

  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next({ name: 'Login', replace: true })
    return
  }

  if (to.matched.some(record => record.meta.guest) && loggedIn) {
    next({ name: 'WorldHome', replace: true })
    return
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js